import ElTableExtend from './src/table-extend';

/* istanbul ignore next */
ElTableExtend.install = function(Vue) {
  Vue.component(ElTableExtend.name, ElTableExtend);
};

export default ElTableExtend;



// WEBPACK FOOTER //
// ./packages/table-extend/index.js